import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { useState } from 'react'
// Login Redux States
import { LOGIN_USER, API_ERROR, LOGOUT_USER, SOCIAL_LOGIN,  SET_RIGHTS,  } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";
import axios from "axios";
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import md5 from 'md5'
import Swal from 'sweetalert2';


const fireBaseBackend = getFirebaseBackend();



function* loginUser({ payload: { user, history } }) {
  const token = localStorage.getItem('Token')
  const auth = `Bearer ${token}`

  const headers = {
    Authorization: auth
  }

  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      var postData = {
        "UserName": user.UserName,
        "password": md5(user.password)
      }
      const response = yield call(
        axios.post,
        `${process.env.REACT_APP_API_URL}/Users/login`,
        postData
      );

      if (response.user && response.user.token) {
        const Response = response.user;
        localStorage.setItem("authUser", JSON.stringify(Response));
        localStorage.setItem("Token", Response.token);
        localStorage.setItem("User_Type", Response.userType);
        localStorage.setItem("default_paractice", Response.defaultPracticeId);
        localStorage.setItem("UserName", Response.userName);
        localStorage.setItem("Emailaddress", Response.email);
        localStorage.setItem("photoUrl", Response.photoUrl);
        localStorage.setItem("Efax", Response.efax);
        localStorage.setItem("unreadFaxCount", Response.unreadFaxCount);
        console.log('email',Response.email)
        localStorage.setItem("UserId", Response.id);
     
             localStorage.setItem("ToDoCount", Response.patientToDoCount);
        localStorage.setItem("rights", JSON.stringify(response.right.value));
        yield put(loginSuccess(Response));
        yield put({ type: SET_RIGHTS, payload: response.right.value });

        history("/dashboard");
      } else {
        Swal.fire({
          title: 'User Name or Password incorrect.',
          icon: 'error',
          confirmButtonColor: '#0BB197',
          confirmButtonText: 'Okay',
        });
        history("/dashboard");
      }
    }
  } catch (error) {
    yield put(apiError(error));
  }
}


function* logoutUser() {
  try {
    // localStorage.removeItem("authUser");
    localStorage.clear();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

// function* socialLogin({ payload: { data, history, type } }) {
//   try {
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const fireBaseBackend = getFirebaseBackend();
//       const response = yield call(fireBaseBackend.socialLoginUser, data, type);
//       localStorage.setItem("authUser", JSON.stringify(response));
//       yield put(loginSuccess(response));
//     } else {
//       const response = yield call(postSocialLogin, data);
//       localStorage.setItem("authUser", JSON.stringify(response));
//       yield put(loginSuccess(response));
//     }
//     history("/dashboard");
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  // yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
